// export const httpRegular = /^https?:\/\/(?:www\.)?([\w.-]+\.[a-zA-Z]{2,})(?:\/.*)?$/

export const tryParseUrl = (v) => {
  try {
    return new URL(v)
  } catch {
    return null
  }
}

export const isValidDomain = (host) => {
  const parts = host.split('.')

  if (parts.length < 2) return false

  const tld = parts[parts.length - 1]

  return !(!tld || tld.length < 2)
}

// export const passwordRegular = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*_-])[A-Za-z\d@$!%*?&-_]+/

export const passwordRegularPart = {
  lowercaseLetter: /(?=.*[a-z])/,
  uppercaseLetter: /(?=.*[A-Z])/,
  number: /(?=.*\d)/,
  specialCharacter: /(?=.*[#?!@$%^&*_-])/,
}

export const phoneRegular = {
  plus: /^[+]/,
  plusAndNumber: /^\+?\d*$/,
  number: /^\d*$/,
}

//^([a-zA-Z0-9_\-\\./]+)@([a-zA-Z0-9_\-\\./]+)\.([a-zA-Z]{2,10})$
export const emailRegular = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,20}$/

export const domainRegular = /^[a-zа-я0-9-]+(\.[a-z0-9-]+)*\.[a-zа-я]{2,}$/i
